import { AfterViewInit, Component, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, forwardRef } from '@angular/core';
import { FormGroup, FormControl, NgControl, Validators, AbstractControl, ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';
import { BaseComponent } from '../../base/base.component';
import { ICustomFields } from 'src/app/shared/models/custom-fields';
import { TranslationService } from 'src/app/shared/services/translation.service';

@Component({
  selector: 'app-custom-number',
  templateUrl: './custom-number.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CustomNumberComponent),
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: CustomNumberComponent
    },
  ]
})
export class CustomNumberComponent extends BaseComponent implements OnInit, ControlValueAccessor, AfterViewInit, OnDestroy, Validator {

  @Output() validationStatusChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() textChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() isRequiredChange: EventEmitter<any> = new EventEmitter<any>();
  private _customField: ICustomFields;

  validationForm: FormGroup;
  customControl: FormControl;
  control: FormControl;
  textVal: string;
  textSelectedVal = { id: '', value: '', type_id: '', required: false, custom_field_usage_link_id: '' };
  form_mode: any;
  private _editCustomFieldList: any[] = [];

  @Input() submit: boolean;
  @Input()
  set customField(val: any) {
    this._customField = val;
  }

  get customField() {
    return this._customField;
  }

  @Input()
  set formsMode(val: any) {
    this.form_mode = val;
  }

  @Input()
  set editCustomFieldList(val: any[]) {
    if (this.form_mode === this.formMode.Edit) {
      this._editCustomFieldList = val;
      this.updateEvent(val)
    }
  }

  get editCustomFieldList() {
    return this._editCustomFieldList;
  }

  constructor(public injector: Injector,
    public translation_service:TranslationService
  ) {
    super();
  }

  ngAfterViewInit(): void {
    const ngControl = this.injector.get(NgControl, null) as NgControl | null;
    if (ngControl) {
      setTimeout(() => {
        this.customControl = ngControl.control as FormControl;
        // If customControl is still undefined, try getting it from the FormGroup
        if (!this.customControl && this.validationForm) {
          this.customControl = this.validationForm.get('customFieldNumber') as FormControl;
        }
      });
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const isValid = !this.isInvalid();
    this.validationStatusChange.emit(isValid);
    const requiredError = this.customField.usage[0].is_required && (!value) ? { required: true } : null;
    return requiredError;
  }

  isInvalid(): boolean {
    return this.customField.usage[0].is_required && (this.control?.touched || this.control?.dirty);
  }

  registerOnValidatorChange?(fn: () => void): void {
    //throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    //throw new Error('Method not implemented.');
  }

  onChanged = (value: any) => { };
  onTouched: Function = () => { };

  ngOnInit(): void {
    const isRequired = this.customField.usage[0].is_required;
    const validators = isRequired ? [Validators.required] : [];

    this.customControl = new FormControl('', validators);

    this.validationForm = new FormGroup({
      customFieldNumber: this.customControl,
    });

    const data = {
      required: isRequired,
      id: this.customField.custom_field_id,
      type_id: this.customField.custom_field_type_id,
      custom_field_usage_link_id: this.customField.usage[0].custom_field_usage_link_id,
      value: this.customField.usage[0].value == undefined ? '' : this.customField.usage[0].value
    }
    this.isRequiredChange.emit(data);
  }

  ngOnDestroy(): void { }

  changeEvent(event: any): void {
    this.onTouched(); // Mark as touched

    this.textVal = event.target.value;

    const newTextSelectedVal = {
      id: this.customField.custom_field_id,
      value: this.textVal,
      type_id: this.customField.custom_field_type_id,
      required: this.customField.usage[0].is_required,
      custom_field_usage_link_id: this.customField.usage[0].custom_field_usage_link_id
    };

    if (this.textSelectedVal.id !== this.customField.custom_field_id) {
      this.textSelectedVal = newTextSelectedVal;
    }

    this.textChange.emit(newTextSelectedVal);

    this.validationStatusChange.emit(this.customControl.valid);
  }

  onValidationStatusChange(): void {
    // Check if customControl is defined before accessing its properties
    if (this.customControl) {
      this.validationStatusChange.emit(this.customControl.valid);
    }
  }

  writeValue(value: string) {
    console.log(value);
  }

  registerOnChange(fn: any): void {
    this.onChanged = fn; // <-- save the function
  }

  registerOnTouched(onTouched: Function) {
    this.onTouched = onTouched;
  }
  
  updateEvent(customValue: any[]) {
    const filteredValues = customValue.filter(f => f.custom_field_id === this.customField.custom_field_id);

    if (filteredValues.length > 0) {
      const selectedValue = filteredValues[0];

      this.textVal = selectedValue.value;

      const textSelectedVal = {
        id: selectedValue.custom_field_id,
        custom_field_usage_link_id: selectedValue.custom_field_usage_link_id,
        value: selectedValue.value,
        type_id: this.customField.custom_field_type_id,
        required: this.customField.usage[0].is_required,
      };

      this.onTouched(); // <-- mark as touched
      this.onChanged(this.textVal);
      this.textChange.emit(textSelectedVal);
    }
  }
}
